// extracted by mini-css-extract-plugin
module.exports = {"checkboxLabel":"Checkbox_checkboxLabel__wSm6S","checkboxInput":"Checkbox_checkboxInput__1xzIv","checkboxControl":"Checkbox_checkboxControl__4mfXN"};